// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'
import { toAdminListParams } from '@/core/lib/table-query'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import {
  emoteDetailQueryOptions,
  emoteListQueryOptions,
} from '@/modules/emote/emote.hooks'
import { emoteSearchSchema } from '@/modules/emote/emote.schemas'

export const emoteRoute = createRoute({
  path: '/emotes',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const emoteListRoute = createRoute({
  getParentRoute: () => emoteRoute,
  path: '/',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'emotes.list',
      'Emoji listesine erişim izniniz yok.'
    )
  },
  head: () => ({
    meta: [
      {
        title: 'Emoji Listesi',
      },
    ],
  }),
  validateSearch: emoteSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    await queryClient.ensureQueryData(
      emoteListQueryOptions(toAdminListParams(deps))
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/emote/pages/list-emote.page')
  ),
})

export const emoteCreateRoute = createRoute({
  getParentRoute: () => emoteRoute,
  path: '/create',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'emotes.create',
      'Emoji oluşturmak için yetkiniz yok.'
    )
  },
  head: () => ({
    meta: [{ title: 'Emoji Oluştur' }],
  }),
  component: lazyRouteComponent(
    () => import('@/modules/emote/pages/create-emote.page')
  ),
})

export const emoteEditRoute = createRoute({
  getParentRoute: () => emoteRoute,
  path: '/$id/edit',
  beforeLoad: async ({ preload }) => {
    return routeHasPermission(
      preload,
      'emotes.edit',
      'Emoji düzenlemek için yetkiniz yok.'
    )
  },
  head: async ({ params: { id } }) => {
    const emote = await queryClient.fetchQuery(emoteDetailQueryOptions(id))

    return {
      meta: [
        {
          title: `Emoji ${emote.name}`,
        },
      ],
    }
  },
  component: lazyRouteComponent(
    () => import('@/modules/emote/pages/edit-emote.page')
  ),
})
